import { render, staticRenderFns } from "./NavContact.vue?vue&type=template&id=455d7f10&scoped=true&"
import script from "./NavContact.vue?vue&type=script&lang=js&"
export * from "./NavContact.vue?vue&type=script&lang=js&"
import style0 from "./NavContact.vue?vue&type=style&index=0&lang=css&"
import style1 from "./NavContact.vue?vue&type=style&index=1&id=455d7f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455d7f10",
  null
  
)

export default component.exports